var map = {
	"./ico_arrow_down.svg": 248,
	"./ico_arrow_down_gray.svg": 436,
	"./ico_back.svg": 3058,
	"./ico_calendar.svg": 5230,
	"./ico_category.svg": 6062,
	"./ico_category_active.svg": 9985,
	"./ico_check.svg": 211,
	"./ico_close.svg": 5808,
	"./ico_close_circle.svg": 6031,
	"./ico_contact.svg": 9632,
	"./ico_contact_active.svg": 6221,
	"./ico_copy.svg": 362,
	"./ico_customer.svg": 217,
	"./ico_customer_active.svg": 9097,
	"./ico_delete.svg": 9695,
	"./ico_delivery.svg": 1195,
	"./ico_delivery_active.svg": 8,
	"./ico_edit.svg": 1606,
	"./ico_edit_blue.svg": 143,
	"./ico_emaillog.svg": 8329,
	"./ico_emaillog_active.svg": 1880,
	"./ico_filter.svg": 1378,
	"./ico_lock.svg": 8107,
	"./ico_move.svg": 6596,
	"./ico_order.svg": 4234,
	"./ico_order_active.svg": 7279,
	"./ico_plus.svg": 4554,
	"./ico_plus_white.svg": 5697,
	"./ico_product.svg": 6373,
	"./ico_product_active.svg": 2906,
	"./ico_school.svg": 6085,
	"./ico_school_active.svg": 8177,
	"./ico_search.svg": 6895,
	"./ico_setting.svg": 6026,
	"./ico_setting_active.svg": 6392,
	"./ico_sort.svg": 7913,
	"./ico_sortt.svg": 2509,
	"./ico_triagle_down.svg": 6712,
	"./ico_uncheck.svg": 4022,
	"./ico_user.svg": 4371,
	"./ico_vendor.svg": 4183,
	"./ico_vendor_active.svg": 5970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1343;